/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Agency,
  CreateRequestBody,
  CreateResponseBody,
  UpdateRequestBody,
} from '../models';
import {
    AgencyFromJSON,
    AgencyToJSON,
    CreateRequestBodyFromJSON,
    CreateRequestBodyToJSON,
    CreateResponseBodyFromJSON,
    CreateResponseBodyToJSON,
    UpdateRequestBodyFromJSON,
    UpdateRequestBodyToJSON,
} from '../models';

export interface AgencyCreateRequest {
    createRequestBody: CreateRequestBody;
}

export interface AgencyReadRequest {
    uuid: string;
}

export interface AgencyUpdateRequest {
    uuid: string;
    updateRequestBody: UpdateRequestBody;
}

/**
 * AgencyApi - interface
 * 
 * @export
 * @interface AgencyApiInterface
 */
export interface AgencyApiInterface {
    /**
     * Create a Transferring Agency
     * @summary create agency
     * @param {CreateRequestBody} createRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    agencyCreateRaw(requestParameters: AgencyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseBody>>;

    /**
     * Create a Transferring Agency
     * create agency
     */
    agencyCreate(requestParameters: AgencyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseBody>;

    /**
     * List all Transferring Agencies
     * @summary list agency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    agencyListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Agency>>>;

    /**
     * List all Transferring Agencies
     * list agency
     */
    agencyList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Agency>>;

    /**
     * Read Transferring Agency by UUID
     * @summary read agency
     * @param {string} uuid UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    agencyReadRaw(requestParameters: AgencyReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Agency>>;

    /**
     * Read Transferring Agency by UUID
     * read agency
     */
    agencyRead(requestParameters: AgencyReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Agency>;

    /**
     * Update a Transferring Agency
     * @summary update agency
     * @param {string} uuid UUID
     * @param {UpdateRequestBody} updateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    agencyUpdateRaw(requestParameters: AgencyUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update a Transferring Agency
     * update agency
     */
    agencyUpdate(requestParameters: AgencyUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class AgencyApi extends runtime.BaseAPI implements AgencyApiInterface {

    /**
     * Create a Transferring Agency
     * create agency
     */
    async agencyCreateRaw(requestParameters: AgencyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseBody>> {
        if (requestParameters.createRequestBody === null || requestParameters.createRequestBody === undefined) {
            throw new runtime.RequiredError('createRequestBody','Required parameter requestParameters.createRequestBody was null or undefined when calling agencyCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/agency`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRequestBodyToJSON(requestParameters.createRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResponseBodyFromJSON(jsonValue));
    }

    /**
     * Create a Transferring Agency
     * create agency
     */
    async agencyCreate(requestParameters: AgencyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseBody> {
        const response = await this.agencyCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all Transferring Agencies
     * list agency
     */
    async agencyListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Agency>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/agency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AgencyFromJSON));
    }

    /**
     * List all Transferring Agencies
     * list agency
     */
    async agencyList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Agency>> {
        const response = await this.agencyListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read Transferring Agency by UUID
     * read agency
     */
    async agencyReadRaw(requestParameters: AgencyReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Agency>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling agencyRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/agency/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyFromJSON(jsonValue));
    }

    /**
     * Read Transferring Agency by UUID
     * read agency
     */
    async agencyRead(requestParameters: AgencyReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Agency> {
        const response = await this.agencyReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a Transferring Agency
     * update agency
     */
    async agencyUpdateRaw(requestParameters: AgencyUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling agencyUpdate.');
        }

        if (requestParameters.updateRequestBody === null || requestParameters.updateRequestBody === undefined) {
            throw new runtime.RequiredError('updateRequestBody','Required parameter requestParameters.updateRequestBody was null or undefined when calling agencyUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/agency/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRequestBodyToJSON(requestParameters.updateRequestBody),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a Transferring Agency
     * update agency
     */
    async agencyUpdate(requestParameters: AgencyUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.agencyUpdateRaw(requestParameters, initOverrides);
    }

}
